<template>
    <div>
        <div class="pos kzgmain">
            <b> 您的位置：</b>
            <a href="/" title="首页"> 首页 </a><span> &gt; </span>
            <router-link :to="{ path: '/HzProduct', query: { name: '产品中心' } }">产品中心</router-link>
            <i v-show="id">
                <span> &gt; </span>
                <router-link :to="{ path: '/HzProduct', query: { id: id, name: name } }"> {{ name }}</router-link>
            </i>
        </div>
        <!-- 控制柜分类 -->
        <div class="pos_bor kzgmain">
            <div class="side">
                <div class="side_tit">
                    <h2>恒智自控<br>product center</h2>
                </div>
                <div class="side_type">
                    <!--  -->
                    <el-menu default-active="number" class="el-menu-vertical-demo" :default-openeds="openeds">
                        <el-submenu v-bind:class="name == menu.name ? 'hov' : ''" :index="menu.name"
                            v-for="(menu, index) in cptypeList" :key="index" @click="onEnterTd(index)">
                            <template slot="title">
                                <span slot="title">{{ menu.name }}</span>
                            </template>
                            <router-link :to="{ path: '/HzProduct', query: { id: item.id, name: item.name } }"
                                v-for="(item, i) in menu.children" :key="i">
                                <el-menu-item :index="item.name">
                                    <span slot="title">{{ item.name }}</span>
                                </el-menu-item>
                            </router-link>
                        </el-submenu>
                    </el-menu>
                    <!-- <div v-bind:class="id == item.id ? 'hov' : ''" v-for="(item, index) in cptypeList" :key="index"
                        @click="onEnterTd(index)">
                        <h3>
                            <router-link class="side_bor"
                                :to="{ path: '/HzProduct', query: { id: item.id, name: item.name } }">
                                {{ item.name }}
                            </router-link>
                        </h3>
                    </div> -->
                </div>
                <div class="side_tit" style="margin-top: 10px;">
                    <!-- <img src="../../images/phone12.png" style="width: 35px;height: 35px;float: left;"> -->
                    <h2>
                        在线联系：<br>
                        0531-83176606
                    </h2>
                </div>
            </div>
            <div class="tab">
                <h2 class="t_name"><span>{{ this.name }}</span></h2>
                <div class="tab_items">
                    <!-- :to="{ path: name == '产品中心' ? '/HzProduct' : '/HzDetails', query: { id: item.ciId, name: name != '产品中心' ? name : item.ciTitle } }" -->
                    <router-link class="tab_item"
                        :to="name == '产品中心' || cptype == '品牌' ? { path: '/HzProduct', query: { id: item.ciId, name: item.ciTitle } } : { path: '/HzDetails', query: { cptitle: '产品中心',id: item.ciId, name: name } }"
                        v-for="(item, index) in infoList" :key="index">
                        <div class="tab_photo">
                            <div class="img_frame">
                                <span class="com_name">济南恒智自控</span>
                                <span class="cpt">{{ item.ciTitle }}</span>
                                <img :alt="item.ciTitle" :src="item.ciCoverPath" :title="item.ciTitle">
                            </div>
                        </div>
                        <div class="tab_detail">
                            <h2>
                                <span>{{ item.ciTitle }}</span>
                            </h2>
                            <p>{{ name == '产品中心' ? item.cmBrief : item.ciOverview }}</p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../js/axios'
import router from '../../router'

export default {
    name: 'HzProduct',
    components: {
        router
    },
    data() {
        return {
            id: this.$route.query.id,
            name: this.$route.query.name,
            cptype: this.$route.query.cptype,
            image: '',
            number: 0,
            cptypeList: [],
            infoList: [],
            openeds: [],
        };
    },
    computed: {},
    watch: {
        $route() {
            if (this.$router.history.current.query.name !== this.name) {
                this.$router.go();
            }
        }
    },
    methods: {
        onEnterTd(index) {
            this.number = index;
            this.openeds.add(index);
        },
        queryCpMenu() {
            http.get('/hzCpTree/cpTree', { params: { menuT: 'P' } }).then((res) => {
                this.cptypeList = res.data.data.result[0].children;
                let brand = [];
                this.cptypeList.forEach(item => {
                    brand.push(item.id)
                })
                window.localStorage.setItem('cpType', JSON.stringify(this.cptypeList));
                this.queryCpInfo(brand);
            })
        },
        queryCpInfo(brand) {
            let cmType = '';
            if (this.name === '产品中心') {
                cmType = this.name;
            } else if (this.name !== '产品中心' && brand.indexOf(parseInt(this.id)) != -1) {
                cmType = '品牌';
            }
            http.get('/hzCpInfo/cpInfo', { params: { cmType: cmType, cmId: this.id } }).then((res) => {
                if (cmType === '品牌' || cmType === '产品中心') {
                    this.infoList = res.data.data.cpBrand;
                    this.infoList.forEach(item => {
                        item.ciId = item.cmTreeId;
                        item.ciTitle = item.cmName;
                        item.ciBrief = item.cmBrief;
                        item.ciCoverPath = this.image + item.cmCoverPath;
                    })
                } else {
                    this.infoList = res.data.data.result;
                    this.infoList.forEach(item => {
                        item.ciCoverPath = this.image + item.ciCoverPath;
                    })
                }
                // console.log(this.infoList);
            })
        }
    },
    created() {
        this.image = http.imageURL
        window.localStorage.setItem('titles', '产品中心');
        this.queryCpMenu();
    },
    mounted() {

    }
}
</script>

<style>
@import "../../config/Control.css"
</style>


// WEBPACK FOOTER //
// src/views/product/HzProduct.vue